import React, {useState, useEffect} from 'react';
import useSound from 'use-sound';
import { playBet, getBets } from "../redux/action"
import LoadingOverlay from 'react-loading-overlay';
import RecentPlays from './RecentPlays'
import FAQ from './FAQ'
import Multipliers from './common/Multipliers'
import Amounts from './common/Amounts'
import { setBetAmount, setBetMultiplier, setLoading, setRecentBets, setShowFaq, setAccordionActiveKey } from "../redux/reducers/storageSlice"
import { Container, Row, Col, Button } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from '../hooks'
import Mixpanel from "mixpanel";
import TokenSelect from './TokenSelect';
import { osName } from 'react-device-detect';
import {
    WalletModalProvider,
    WalletMultiButton,
} from '@solana/wallet-adapter-react-ui';
import {
    useWallet
} from '@solana/wallet-adapter-react';
import axios from 'axios';
import winSound from '../sounds/Win.mp3';
import lossSound from '../sounds/Loss.mp3';
LoadingOverlay.propTypes = undefined

const Main: React.FC = () => {
    const dispatch = useAppDispatch();
    const [playWin] = useSound(winSound);
    const [playLoss] = useSound(lossSound);
    const solBalance = useAppSelector(state => state.storage.solBalance)
    const [playerDetails, setPlayerDetails] = useState({country: "none", OS: "none"})
    const [gameState, setGameState] = useState("not playing")
    const [subMsgs, setSubMsgs] = useState([])
    const [loaderActive, setLoaderActive] = useState(false)
    const [loaderImage, setLoaderImage] = useState("images/trident1.gif")
    const [loaderMsg, setLoaderMsg] = useState("")
    const sound = useAppSelector(state => state.storage.sound)
    const betMultiplier = useAppSelector(state => state.storage.betMultiplier)
    const betAmount = useAppSelector(state => state.storage.betAmount)
    const selectedToken = useAppSelector(state => state.storage.token)
    const walletConnected = useAppSelector(state => state.storage.wallet)
    const mixpanel = Mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN_ID);
    const wallet = useWallet()
    const mode = useAppSelector(state => state.storage.mode)

    useEffect(() => {
        if ((mode != "Degen") && (mode != "Token")) getRecentBets()
        // getGeoInfo()
    }, []);

    useEffect(() => {
        if (walletConnected) dispatch(setAccordionActiveKey("1"))
    }, [walletConnected])

    const getGeoInfo = () => {
        axios.get('https://ipapi.co/json/').then((response) => {
            let data = response.data;
            setPlayerDetails({country: response.data.country_name, mobile: isMobile, OS: osName })
            // console.log(playerDetails)
        }).catch((error) => {
            console.log(error);
        });
    };

    const getRecentBets = async () => {
        const data  = await getBets();
        dispatch(setRecentBets(data))          
    }

    const setLost = () => {
        setLoaderImage("images/lost.gif")
        setGameState("lost")
        dispatch(setLoading("lost"))
        if (sound) playLoss();
        let msg = "YOU LOST A " + betMultiplier + "X BET WITH " + betAmount + " SOL."
        setLoaderMsg(msg)
    }

    const setWon = () => {
        setLoaderImage("images/won.gif")
        setGameState("won")
        dispatch(setLoading("won"))
        if (sound) playWin();
        let betWin = betMultiplier * betAmount
        let msg = "YOU WON " + betWin  + " ON A " + betMultiplier +"X BET!!!"
        setLoaderMsg(msg)              
    }

    const play = async () => {
        dispatch(setAccordionActiveKey("1"))
        if (solBalance < (betAmount * 1.1)){
            setLoaderImage("images/notenoughsol.gif")
            setLoaderMsg("YOU DO NOT HAVE ENOUGH SOL TO PLAY")
            setGameState("not enough sol")
            setLoaderActive(true)
        } else {
            dispatch(setLoading("loading"))
            setGameState("playing")
            setLoaderImage("images/trident1.gif")
            let msg = "Playing " + betMultiplier + "x bet with " + betAmount + " SOL."
            setLoaderMsg(msg)
            setLoaderActive(true)
            try {
                const data = await playBet(betAmount, betMultiplier, wallet, dispatch, setBetAmount, setBetMultiplier, setLoaderMsg, setGameState, setLoaderImage)
                let coin = "SOL"
                if (data.status =="success"){
                    if (data.won){
                        setWon()
                        let mixData = {
                            amount: data.amount,
                            multiplier: data.multiplier,
                            won: data.won,
                            coin: coin,
                            ...playerDetails
                        }
                        // console.log("logging", JSON.stringify(mixData))
                        mixpanel.track('event name', mixData);                    
                    } else {
                        let mixData = {
                            amount: data.amount,
                            multiplier: data.multiplier,
                            won: data.won,
                            coin: coin,
                            ...playerDetails
                        }
                        // console.log("logging", JSON.stringify(mixData))
                        mixpanel.track('event name', mixData);                    
                        setLost()
                    } 
                    if (mode == "Token") getRecentBets()()
                } else if (data.status =="cancelled") {
                    setLoaderActive(false)
                } else if ((data.status =="error encountered") || (data.status =="paused game")) {
                    setGameState(data.status)
                    setLoaderImage(data.loaderImg)
                    setLoaderMsg(data.msg)
                    setSubMsgs(data.subMsgs)
                }

            } catch (err) {
                console.log(err)
                setGameState("error encountered")
                setLoaderImage("images/networkcongestion.gif")
                setLoaderMsg("Solami Rugged")
                setSubMsgs([`An Error has occurred in the Network`, "Please check Solscan to see if the bet was processed.","If SOL was taken, but the bet was not completed, your next bet will display the result for Free."])
            }
        }
    }
    const playAgainButtonClick = () => {
        setLoaderActive(false)
        setGameState("not playing") 
    }

    let betButtonMsg = "PLAY"
    if ((betAmount * betMultiplier) !== 0) betButtonMsg = "PLAY TO WIN " + (betAmount * betMultiplier) + " SOL"
    let loaderDiv = (
        <div className="col-md-12">
            <img alt="not found" src={loaderImage} style={{width: "50%"}}/>
            <h4 style={{color: "black"}}>{loaderMsg}</h4>
            {(loaderImage =="images/won.gif" || loaderImage =="images/lost.gif") ? <Button variant="outline-danger" style={{marginTop: 20, margin: 10}} onClick={() => playAgainButtonClick()}><h3>Play Again</h3></Button>: null}
        </div>
    )
    if (gameState =="won"){
        loaderDiv = (
            <div className="col-md-12">
                <img alt="not found" src={loaderImage} style={{width: "50%"}}/>
                <h4 style={{color: "black"}}>{betMultiplier}X YOU WON!</h4>
                <h4 style={{color: "green", fontWeight: "bold"}}>+{betAmount * betMultiplier} SOL</h4>
                {(loaderImage =="images/won.gif" || loaderImage =="images/lost.gif") ? <Button variant="outline-danger" style={{marginTop: 20, margin: 10}} onClick={() => playAgainButtonClick()}><h3>Play Again</h3></Button>: null}
            </div>
        )
    } else if (gameState =="lost"){
        loaderDiv = (
            <div className="col-md-12">
                <img alt="not found" src={loaderImage} style={{width: "50%"}}/>
                <h4 style={{color: "black"}}>YOU LOST</h4>
                <h4 style={{color: "red"}}>{betAmount} SOL</h4>
                {(loaderImage =="images/won.gif" || loaderImage =="images/lost.gif") ? <Button variant="outline-danger" style={{marginTop: 20, margin: 10}} onClick={() => playAgainButtonClick()}><h3>Play Again</h3></Button>: null}
            </div>
        )
    } else if (gameState =="error encountered"){
        let subMsgArr = subMsgs.map((subMsg, i) => 
            <h5 style={{color: "#2a2a2a"}} key={i+1}>{subMsg}</h5>
        )
        loaderDiv = (
            <div className="col-md-12">
                <img alt="not found" src={loaderImage} style={{width: "50%"}}/>
                <h4 style={{color: "black"}}>{loaderMsg}</h4>
                {subMsgArr}
                <Button variant="outline-danger" style={{marginTop: 20, margin: 10}} onClick={() => play()}><h3>Retry</h3></Button>
                <Button variant="outline-danger" style={{marginTop: 20, margin: 10}} onClick={() => setLoaderActive(false)}><h3>Cancel</h3></Button>
            </div>
        )
    } else if (gameState =="paused game"){
        let subMsgArr = subMsgs.map((subMsg, i) => 
            <h5 style={{color: "#2a2a2a"}} key={i+1}>{subMsg}</h5>
        )
        loaderDiv = (
            <div className="col-md-12">
                <img alt="not found" src={loaderImage} style={{width: "50%"}}/>
                <h4 style={{color: "black"}}>{loaderMsg}</h4>
                {subMsgArr}
                <Button variant="outline-danger" style={{marginTop: 20, margin: 10}} onClick={() => play()}><h3>Retry</h3></Button>
                <Button variant="outline-danger" style={{marginTop: 20, margin: 10}} onClick={() => setLoaderActive(false)}><h3>Cancel</h3></Button>
            </div>
        )
    } else if (gameState =="not enough sol"){
        loaderDiv = (
            <div className="col-md-12">
                <img alt="not found" src={loaderImage} style={{width: "50%"}}/>
                <h4 style={{color: "black"}}>{loaderMsg}</h4>
                <Button variant="outline-danger" style={{marginTop: 20, margin: 10}} onClick={() => playAgainButtonClick()}><h3>Play</h3></Button>
            </div>
        )
    }

    return (
        <Container>                 
          <LoadingOverlay
            active={loaderActive}
            styles={{
              overlay: (base) => ({
                ...base,
                background: 'rgba(255, 255, 255, 0.9)',
                height: "100%!important"
              })
            }}
            spinner={
              (
                <div className="container-fluid">
                  {loaderDiv}
                </div>
              )
            }
            >
            <Container style={{paddingLeft: "5%",paddingRight: "5%"}}>
                <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                    <Col style={{marginBottom: 30}}>

                    </Col>
                </Row>
                {walletConnected ? (
                    <div>
                        <Row style={{ paddingBottom: 40, justifyContent: 'center'  }}>
                            <TokenSelect/>
                        </Row>
                        <Multipliers/>
                        <Row style={{paddingBottom: 20,paddingTop: 20}}>
                            <h3 style={{color: "white"}}>FOR</h3>
                        </Row>
                        <Row style={{paddingBottom: 20, display: 'flex', justifyContent: 'center'}}>
                            <Amounts/>
                        </Row>               
                        <Row style={{paddingBottom: 20,paddingTop: 20}}>
                            <Col>
                                <Button variant='light' disabled={(walletConnected ==null) || ((betAmount ==0) || (betMultiplier ==0))} style={{width: '100%'}} onClick={() => play()}><h2 style={{color: "black"}}>{betButtonMsg}</h2></Button>
                            </Col> 
                        </Row>       
                    </div>
                    ) 
                    :
                    (
                        <Container>
                                <WalletModalProvider>
                                    <WalletMultiButton style={{margin: "auto"}}/>
                                </WalletModalProvider>
                        </Container>
                    )
                }   

                </Container>
                <RecentPlays />
                <div style={{width: "100%", textAlign: "center", marginBottom: 40}}>
                <a href='javascript:void(0)' onClick={() => {
                        // console.log("MODALING");
                        dispatch(setShowFaq(true));
                    }
                }>
                    <h4>FAQ</h4>
                    </a>
                </div>
                <FAQ/>
            </LoadingOverlay>
        </Container>
    );
}

export default Main;